import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  icon: {
    fontSize: 26,
    fontWeight: 700,
    color: '#7df3e1',
    fontFamily: 'Helvetica, Arial, sans-serif',
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return <span className={classes.icon}>D</span>;
};
